 
export const defaultSorted = [{ dataField: "id", order: "asc" }];
// export const PatientStatusCssClasses = ["danger", "success", "info", ""];
export const PatientStatusCssClasses = {success:"success",pending:"info",failed:"danger"};
// export const PatientStatusTitles = ["suspended", "active", "pending", ""];
export const PatientStatusTitles = {success:"Success",pending:"Pending",failed:"Failed"}
export const sizePerPageList = [ 
  { text: "10", value: 10 }
];
export const initialFilter = {
  filter: {
    model: "",
    manufacture: "",
    VINCode: ""
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10
}; 
